export default __webpack_public_path__ + "static/media/warning-mark-red.63109da0.svg";